<template>
  <transition-group
    v-if="isOpened"
    name="c-notice-fade"
    appear
  >
    <div
      @click="$emit('close')"
      class="c-notice"
      :key="name + 'notice'"
    >
      <div
        class="content"
        @click="$emit('action')"
      >
        <div
          class="image"
          :style="{ 'background-image': `url(${isDesktop ? desktopNotice : mobileNotice})` }"
        />
        <c-button
          size="lg"
          icon="cross"
          class="close"
          ghost
          @click.stop="$emit('close')"
        />
      </div>
    </div>
  </transition-group>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    isOpened: Boolean,
    desktopNotice: {
      type: String,
      required: true
    },
    mobileNotice: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
@import '~@style/reference';

.c-notice {
  position: fixed;
  z-index: 10;
  overflow: hidden;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  left: 0;
  min-height: 100%;
  background-color: rgba(black, 0.5);

  & > .content {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    min-width: 560px;
    height: 300px;

    @include mobile {
      min-width: 300px;
      height: 440px;
    }

    & > .image {
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: contain;
      cursor: pointer;

      @include mobile {
        background-size: cover;
      }
    }

    & > .close {
      position: absolute;
      top: 0;
      right: 0;
      margin: 10px;

      & > .icon { fill: white !important }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/CComponents/CNotice.vue